import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

export const useReadingSettings = () => {
  const { theme, setTheme, mode, themeOptions } = useTheme();
  
  const [fontSize, setFontSize] = useState(() => {
    const saved = localStorage.getItem('readingFontSize');
    return saved !== null ? parseFloat(saved) : 2;
  });

  const [showNotesPanel, setShowNotesPanel] = useState(() => {
    const saved = localStorage.getItem('showNotesPanel');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const toggleNotesPanel = () => {
    const newValue = !showNotesPanel;
    setShowNotesPanel(newValue);
    localStorage.setItem('showNotesPanel', JSON.stringify(newValue));
  };

  const changeFontSize = (delta) => {
    const newSize = Math.max(1, Math.min(4, fontSize + delta));
    setFontSize(newSize);
    localStorage.setItem('readingFontSize', newSize.toString());
  };

  return {
    theme,
    setTheme,
    mode,
    themeOptions,
    fontSize,
    setFontSize, // Export setter if needed directly
    changeFontSize,
    showNotesPanel,
    toggleNotesPanel
  };
};

